// Copyright (c) Microsoft. All rights reserved.

import { useMsal } from '@azure/msal-react';
import { Body1, Button,  Title3, Subtitle1 } from '@fluentui/react-components';
import React from 'react';
import { useSharedClasses } from '../../styles';
import { getErrorDetails } from '../utils/TextUtils';

export const Login: React.FC = () => {
    const { instance } = useMsal();
    const classes = useSharedClasses();

    return (
        <div className={classes.informativeView}>
            <Title3>Melden Sie sich mit Ihrer E-Mail-Adresse an</Title3>
            <Body1>
                {"Sie haben keinen Zugang?  Jetzt buchen über"}{' '}
                <a href="https://www.anlei-service-gmbh.de/" target="_blank" rel="noreferrer">
                    https://www.anlei-service-gmbh.de/
                </a>
            </Body1>

            <Button
                style={{ padding: '0.5em 5em', border: '1px solid #d3d3d3', color: 'gray', backgroundColor: 'white', 
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', borderRadius: '4px', marginTop: '1em' }}
                appearance="transparent"
                onClick={() => {
                    instance.loginRedirect().catch((e: unknown) => {
                        alert(`Error signing in: ${getErrorDetails(e)}`);
                    });
                }}
                data-testid="signinButton"
            >
                <Subtitle1> Anmelden</Subtitle1>
            </Button>
        </div>
    );
};